import React from "react";
import { AlertTriangleIcon } from "../../../../svg/alertTriangle";
import { RedFlagIcon } from "../../../../svg/redFlag";

interface StringWithIconCellProps {
  value: {
    text: "";
    shouldShowBlockedIcon?: false;
    shouldShowAlertIcon?: false;
    textWidth?: string;
  };
  [key: string]: any;
}

export const StringWithIconCell: React.FC<StringWithIconCellProps> = ({
  value,
}) => {
  return (
    <>
      <div className="table-cell-multiline-text">
        <div className="flex items-center gap-3">
          <div
            title={value.text}
            className="truncate"
            style={{
              maxWidth: value.textWidth,
              flexShrink: 0,
            }}
          >
            {value.text}
          </div>
          {value.shouldShowAlertIcon && <AlertTriangleIcon />}
          {value.shouldShowBlockedIcon && (
            <RedFlagIcon height={14} width={9.8} />
          )}
        </div>
      </div>
    </>
  );
};

export default StringWithIconCell;
